import { render, staticRenderFns } from "./EstimatedCopy.vue?vue&type=template&id=66b333f3&scoped=true"
import script from "./EstimatedCopy.vue?vue&type=script&lang=js"
export * from "./EstimatedCopy.vue?vue&type=script&lang=js"
import style0 from "./EstimatedCopy.vue?vue&type=style&index=0&id=66b333f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b333f3",
  null
  
)

export default component.exports